import vslQueries from "$/lib/queries/vsl-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/(app)/_auth/vsl/$vslId/versions/$versionId",
)({
  loader: async ({ context: { queryClient }, params: { versionId } }) => {
    const stats = await queryClient.ensureQueryData(
      vslQueries.versionStats(versionId),
    )
    return { crumb: `${stats.vslTitle} v${stats.version.number}` }
  },
})
